var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-line",class:{ border: _vm.showBorder }},[_c('div',{staticClass:"left"},[_vm._t("default")],2),_c('div',{staticClass:"right password-field"},[_vm._t("right"),(_vm.isLink)?_c('span',{staticClass:"iconfont arrow"},[_vm._v("")]):_vm._e(),(_vm.isPassword)?_c('span',{staticClass:"password-toggle",class:{
        'password-visible': _vm.showPassword,
        'password-hidden': !_vm.showPassword,
      },on:{"click":_vm.toggleVisibility}}):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }